export type DiscreteTempo = 'VERY_SLOW' | 'SLOW' | 'MEDIUM' | 'NORMAL'
type DiscreteTempoToPercentageArray = {
  // False negative here
  // eslint-disable-next-line no-unused-vars
  [DiscreteTempoValue in DiscreteTempo]: number;
}
export interface DiscreteTempoByTargetBPMConfig {
  maxSpeed: number;
  tempos: DiscreteTempoToPercentageArray;
}
export const discreteTempoPercentage = [
  {
    maxSpeed:  70,
    tempos: {
      'VERY_SLOW': 0.7,
      'SLOW': 0.8,
      'MEDIUM': 0.9,
      'NORMAL': 1,
    }
  },
  {
    maxSpeed: 90,
    tempos: {
      'VERY_SLOW': 0.5,
      'SLOW': 0.7,
      'MEDIUM': 0.85,
      'NORMAL': 1,
    }
  },
  {
    maxSpeed: 120,
    tempos: {
      'VERY_SLOW': 0.5,
      'SLOW': 0.65,
      'MEDIUM': 0.85,
      'NORMAL': 1,
    },
  },
  {
    maxSpeed: 240,
    tempos: {
      'VERY_SLOW': 0.5,
      'SLOW': 0.75,
      'MEDIUM': 0.88,
      'NORMAL': 1,
    }
  }
];
export function getDiscreteTempo(targetBpm: number, discreteTempo: DiscreteTempo): number {
  const configIndex = discreteTempoPercentage.findIndex(
    (config) => config.maxSpeed > targetBpm
  );
  return discreteTempoPercentage[configIndex].tempos[discreteTempo];
}

// Before we used a with message to find it check an old commit with name containing "remove discrete tempo message"
export function getIncreasedTempo(targetBpm: number, speed: number) {
  if (speed < getDiscreteTempo(targetBpm, 'SLOW')) {
    return getDiscreteTempo(targetBpm, 'SLOW');
  }
  else if (speed < getDiscreteTempo(targetBpm, 'MEDIUM')) {
    return getDiscreteTempo(targetBpm, 'MEDIUM');
  }
  else {
    return getDiscreteTempo(targetBpm, 'NORMAL');
  }
}
export function getDecreasedTempo(targetBPM: number, speed: number) {
  if (speed > getDiscreteTempo(targetBPM, 'MEDIUM')) {
    return getDiscreteTempo(targetBPM, 'MEDIUM');
  }
  else if (speed > getDiscreteTempo(targetBPM, 'SLOW')) {
    return getDiscreteTempo(targetBPM, 'SLOW');
  }
  else {
    return getDiscreteTempo(targetBPM, 'VERY_SLOW');
  }
}
